import Vue from 'vue'
import Router from 'vue-router'

const baseRouter = [{
  path: '',
  component: () => import('@/views/main')
}, {
  path: '/',
  component: () => import('@/views/main')
}, {
  path: '/cont/:id/:type',
  component: () => import('@/views/cont')
}]

Vue.use(Router)

const routerArr = [].concat(
  baseRouter
)

const router = new Router({
  caseSensitive: true,
  mode: 'history',
  scrollBehavior () {
    return {
      x: 0,
      y: 0
    }
  },
  routes: routerArr
})

export default router